import React from 'react'

export default function Close({ fill = '#0D342D' }) {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7029 0.353553C16.8982 0.158291 17.2147 0.158291 17.41 0.353553L18.5029 1.44645C18.6982 1.64171 18.6982 1.95829 18.5029 2.15355L3.01 17.6464C2.81474 17.8417 2.49815 17.8417 2.30289 17.6464L1.21 16.5536C1.01474 16.3583 1.01474 16.0417 1.21 15.8464L16.7029 0.353553Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.01 0.353553C2.81474 0.158291 2.49815 0.158291 2.30289 0.353553L1.21 1.44645C1.01474 1.64171 1.01474 1.95829 1.21 2.15355L16.7029 17.6464C16.8982 17.8417 17.2147 17.8417 17.41 17.6464L18.5029 16.5536C18.6982 16.3583 18.6982 16.0417 18.5029 15.8464L3.01 0.353553Z"
        fill={fill}
      />
    </svg>
  )
}
